<template lang="html">
  <div class="wrapper -al-dia">

    <div class="encabezado">

      <div class="container column-start">
        <div class="contenedor-logo">
          <router-link to="/">
            <img src="/static/img/UFV-logo.png" alt="Logo UFV">
          </router-link>
        </div>
        <h1>Al día</h1>

      </div>

    </div>

    <div class="migas">
      <div class="container">
        <nav class="row-start">
          <router-link to="/">Home</router-link>
          <router-link :to="$t('enlaces.aldia')">Al día</router-link>
        </nav>
      </div>
    </div>

    <section class="buscador">

      <filtro v-model="filter" :both="true" :position="'-1'"></filtro>

      <div class="contenedor-resultados container row-start ais" v-if="!!elements && elements.length != 0">

        <template v-for="(el,key) in elements.slice((perpage*page)-perpage,perpage*page)" >
          <evento :el="el" v-if="filter.type == 'eventos'" :key="key"></evento>
          <noticia :el="el" v-if="filter.type == 'noticias'"></noticia>
        </template>

        <div class="contenedor-paginador row-center" v-if="pages > 1">
          <a @click="prev" class="prev"></a>
          <a :active="n == page" @click="setPage(n)" v-for="n in pages">{{n}}</a>
          <a @click="next" class="next"></a>
        </div>


      </div>

      <p v-else>No hay contenido en estos momentos</p>

    </section>


    <section class="al-dia-home">

      <div class="container row-between">

        <template v-if="filter.type == 'noticias'">
          <h2 class="big-bold-title">Noticias</h2>
          <div class="contenedor-noticias row-start ais" v-if="!!noticias">
            <noticia :el="el" v-for="(el,key) in noticias.slice(0,3)" :key="key"></noticia>
          </div>
          <div class="contenedor-boton row-center">
            <router-link :to="$t('enlaces.aldia')+'?noticias'" class="btn -skull">Todos las noticias</router-link>
          </div>
        </template>

        <template v-if="filter.type == 'eventos'">
          <h2 class="big-bold-title">Eventos</h2>
          <div class="contenedor-eventos row-start ais" v-if="!!eventos">
            <evento :el="el" v-for="(el,key) in eventos.slice(0,3)" :key="key"></evento>
            
          </div>
          <div class="contenedor-boton row-center">
            <router-link :to="$t('enlaces.aldia')+'?eventos'" class="btn -skull">Todos los eventos</router-link>
          </div>
        </template>


      </div>

    </section>


  </div>

</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex';

  import filtro from '@/components/parts/filtro'

  import evento from '@/components/parts/evento-el';
  import noticia from '@/components/parts/noticia-el';
  export default {
    name: 'al-dia',
    data() {
      return {
        filter: '',
        page: 1,
        perpage: 9
      }
    },
    
    computed: {
      ...mapGetters({
        noticias: 'getNoticiasDia',
        eventos: 'getEventosDia'
      }),
      elements() {
   

        let elements;

        this.page = 1;
			

        if (!!this.filter) {

          elements = this[this.filter.type];
         


          //AREAS
          if (!!this.filter.area) {
            elements = elements.filter(e => (e.area.some(a => a.slug == this.filter.area)));
          }

          if (!!this.filter.categoria) {
            elements = elements.filter(e => (e.categoria.some(a => a.slug == this.filter.categoria)));
           
          }

          if (!!this.filter.titulos) {
            elements = elements.filter(e => (e.titulos.some(a => a.slug == this.filter.titulos.slug)));
          }

          if (!!this.filter.tags) {
            elements = elements.filter(e => {
              let existe = false;

              if (!!e.tags) {
                e.tags.forEach(t => {
                  (this.filter.tags.some(tag => tag == t)) ? existe = true : null;
                })
              }

              return existe;

            });
          }
   

          if (!!this.filter.search) {

            let searchIn = ['titulo', 'entradilla'];


            elements = elements.filter(element => {
             
              let can = false;

              searchIn.forEach(where => {
                (element[where].toLowerCase().includes(this.filter.search.toLowerCase())) ? can = true : '';
              });

              return (can) ? element : '';
            });

          }

          if (!!this.filter.fecha) {
            let actual = new Date().getTime();
            const SEMANAVAL = 604800000;
            let limit;
            switch (this.filter.fecha) {
              case 'day':
                limit = (actual - SEMANAVAL);
                break;
              case 'month':
                limit = (actual - SEMANAVAL * 4);
                break;
              case 'ever':
                limit = 0;
                break;
            }

            elements = elements.filter(o => {
              let fecha = new Date(o.fecha.full).getTime();
              return (fecha >= limit);
            });


          }

        } else {

          if (!!this.eventos && !!this.noticias) {
            elements = this.noticias.concat(this.eventos);
      
          } else {
            elements = [];
          }

        }


        if (!!elements && elements.length > 1) {
           

          elements.sort((a, b) => {
            return new Date(b.fecha.full).getTime() - new Date(a.fecha.full).getTime();
          });

        }

        return elements;
        
         
      },
      pages() {
        return Math.ceil(this.elements.length / this.perpage);
      }
    },
    methods: {
      prev() {
        if (this.page > 1) {
          this.page--;
          $("html,body").animate({ scrolltop: 0 }, 500)
        }
      },
      next() {
        if (this.page < this.pages) {
          this.page++;
          $("html, body").animate({ scrollTop: $(".contenedor-resultados").offset().top }, 800);
        }
      },
      setPage(page) {
        this.page = page;
      },
    },
    components: {
      'filtro': filtro,
      'evento': evento,
      'noticia': noticia,
    },
    filters: {
      stringcategoria(value) {


        let cats = new Array();
        value.forEach(v => {
          cats.push(v.nombre);
        })

        let last = cats.pop();
        if (value.length != 1) {
          return cats.join(", ") + ' y ' + last;
        } else {
          return last;
        }
      }
    }
  }



</script>

<style scoped lang="scss">
  .error-404 {}
</style>


// WEBPACK FOOTER //
// src/components/views/al-dia.vue